import { VF_LOOKUP_TABLE } from 'AppSrc/core/components/forms/form-base-components/v-f-lookup-table';
import {
  INLINE_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import {
  PROJECT_CODE,
} from 'AppSrc/core/components/forms/form-types/create-crq/relationships/relationships-modal/relationship-constants';
import { searchProjects } from 'AppSrc/core/relationships/relationships-queries';
import {
  MOBILE,
  // RT_PROJECT_CODE,
} from 'AppSrc/core/components/forms/value-dependency-constants';

const fieldId = PROJECT_CODE;

const initialValues = '';

const resultsColumns = [
  { id: 'name', label: 'Project code' },
  { id: 'id', label: 'CI ID' },
  { id: 'serial', label: 'Serial Number' },
  { id: 'product', label: 'Product' },
  { id: 'organisation', label: 'Company' },
  { id: 'status', label: 'CI Status' },
];

// At the moment the example projects returned from TIL do not send values for
// id, serial or product. For now we will use the name as the ref_id for a project
// This may change once we connect to TIL
const getRelationshipForProjectCode = (projectCode) => {
  if (!projectCode) { return null; }
  const {
    name,
    status,
    ciType, // fixed for dynamic reference type in CI
    reconcilationId, // fixed for uat defect CI's & Node CI's in ACE
  } = projectCode;
  return ({
    name,
    referenceId: name, // ref ID is name
    referenceType: ciType, // fixed for dynamic reference type in CI
    status,
    reconcilationId, // fixed for uat defect CI's & Node CI's in ACE
  });
};

const getSearchResultForProjectCode = (projectCode) => {
  const {
    name,
    organisation,
    status,
  } = projectCode;
  return ({
    id: name,
    columnValues: {
      name,
      organisation,
      status,
    },
    value: getRelationshipForProjectCode(projectCode),
  });
};

const getSelectedIdForValue = (value) => value && value.referenceId;
const getInitialSearchQueryForValue = (value) => value && value.name;

const performSearch = (searchQuery) => searchProjects(MOBILE, searchQuery)
  .then((projectCodes) => projectCodes.map(getSearchResultForProjectCode));

const vFParams = {
  fieldTitle: 'Project code',
  placeholder: 'Search project codes',
  performSearch,
  resultsColumns,
  getSelectedIdForValue,
  getInitialSearchQueryForValue,
};

const validator = (params) => {
  const {
    values,
  } = params;
  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(values[fieldId], VF_LOOKUP_TABLE);

  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push(noValue ? 'Please enter a project code' : null);

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};

const projectCode = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  fieldType: VF_LOOKUP_TABLE,
};

export { projectCode };
